import React from 'react'
import i18n from 'i18next'
import actions from 'redux-auto'
import {useAuth} from 'oidc-react'
import Headline from '#components/a/Headline'
import Text from '#components/a/Text'
import Button from '#components/a/Button'

const LoginError = () => {
  const auth = useAuth()
  async function logout(e) {
    e.preventDefault()
    actions.authentication.resetUserData()
    await auth.signOutRedirect({})
  }

  return (
    <div className="loginError">
      <div className="content-box">
        <Headline modifier="section" importance={2} text={i18n.t('login_error_user_data_invalid_header')} />
        <Text text={i18n.t('login_error_user_data_invalid')} />
        <div className="loginErrorButtons">
          <Button event={logout} text={i18n.t('logout')} variant="primary" />
        </div>
      </div>
    </div>
  )
}

export default LoginError
